export { default as Grid2 } from "@mui/material/Unstable_Grid2";
// export { default as GridItem } from '@mui/material/GridItem'
export type { Grid2Props } from "@mui/material/Unstable_Grid2";
